<script setup lang="ts">
const route = useRoute<"variant">()
const productContent = useProductContentStore()
const products = useProductVariantsStore()

useHead({
  bodyAttrs: {
    class: "bg-[--theme-darkest]",
  },
})

// Watch for the query parameter and navigate to first free subject
watchEffect(async () => {
  const toFreeChapter = route.query["til-gratis-kapittel"]
  const subjectsLoaded =
    !productContent.hydrationInProgress &&
    productContent.subjects.length > 0

  if (toFreeChapter && subjectsLoaded) {
    const hasFreeSubject = productContent.subjects.find(
      subject => subject.isFree,
    )

    if (hasFreeSubject?.frontendHref) {
      await navigateTo(hasFreeSubject.frontendHref, { replace: true })
    } else {
      await navigateTo({
        path: route.path,
        query: { ...route.query, "til-gratis-kapittel": undefined },
      }, {
        replace: true,
      })
    }
  }
})
</script>

<template>
  <UFeatureFlag
    class="fixed left-0 top-0 z-50 w-fit p-4 text-gray-400"
  >
    <UButton
      to="/"
      variant="quite"
      size="sm"
      theme="white"
    >
      kunne.no
    </UButton>
  </UFeatureFlag>

  <div
    class="flex w-full items-center justify-center bg-[--theme-darkest]"
  >
    <div
      class="flex w-full max-w-[1465px] flex-col items-center justify-center px-9 md:flex-row md:items-start md:gap-16 lg:px-20"
    >
      <USideNav
        :data="productContent.subjectNav"
        :product="products.activeVariant"
        :folders="productContent.folders"
        :licence="products.activeVariant?.userHasLicence"
        page-type="product"
      />
      <main class="w-full">
        <UMyProfileButton
          :path="[route.params.product, route.params.variant]"
        />
        <slot />
      </main>
    </div>
  </div>
  <UBottomPanel />
</template>
